import React, { Component } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'
import * as styles from './index.module.css'

export default class CustomersInSecurity extends Component {
  render() {
    var props = this.props

    return (
      <div className="wrapper">
        <div className={styles.container}>
          <h2>{props.title}</h2>

          <div className={styles.customerContainer}>
            {props.components.map((comp, idx) => (
              <Link to={comp.ctaUrl} key={idx} target="_blank">
                <GatsbyImage
                  image={comp.gatsbyImageData}
                  className={styles.image}
                  imgStyle={{ objectFit: 'contain' }}
                  alt={comp?.image?.description}
                />
                {JSON.stringify(comp)}
              </Link>
            ))}
          </div>

          <GatsbyImage
            image={props.images[0].gatsbyImageData}
            className={styles.bigImage}
            imgStyle={{ objectFit: 'cover' }}
            alt={props?.images[0]?.description}
          />
        </div>
      </div>
    )
  }
}
